import { AppForm } from '../../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ParcelAppEntityParcelWrite
} from '../../../../../../../openapi';

@Injectable()
export class AccessToPublicRoadLocalisationForm extends AppForm {
  constructor() {
    super({
      parcels: new FormControl<ParcelAppEntityParcelWrite[]>([], {
        nonNullable: true,
        validators: [Validators.required, Validators.minLength(1)]
      }),
      description: new FormControl(null, [Validators.maxLength(5000)])
    });
  }

  public get parcels(): FormControl {
    return this.get('parcels') as FormControl;
  }

  public get parcelsValues(): ParcelAppEntityParcelWrite[] {
    return this.parcels.value;
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    const value = this.value;
    delete value.parcels;
    return value;
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchValue({
      ...value
    });
    if (!!value.parcels?.length) {
      this.parcels.setValue(value.parcels);
    }
  }


}
